import axios from 'axios';
import router from '@/router';

const api = axios.create({
    baseURL: 'https://hqndani.sheriahousing.co.ke/',
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    },
    withCredentials: true,
    timeout: 30000
});

// Request interceptor — attach auth token automatically
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('access_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor — handle 401 globally
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('user');
            localStorage.removeItem('member');
            router.push('/user-login');
        }
        return Promise.reject(error);
    }
);

export default api;
